import React from 'react';
import { InputNumber } from 'primereact/inputnumber';
import PropTypes from 'prop-types';

const InputNumberPM = ({
  inputId = null,
  value = null,
  onValueChange = null,
  mode = null,
  min = null,
  max = null,
  maxIntegerDigits = null,
  fractionDigits = null,
  suffix = null,
  showButtons = false,
  className = '',
  placeholder = '',
}) => {
  InputNumberPM.propTypes = {
    inputId: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onValueChange: PropTypes.func,
    mode: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    maxIntegerDigits: PropTypes.number,
    fractionDigits: PropTypes.number,
    suffix: PropTypes.string,
    showButtons: PropTypes.bool,
    className: PropTypes.string,
    placeholder: PropTypes.string,
  };

  return (
    <InputNumber
      inputId={inputId}
      className={`InputNumber ${className}`}
      value={value}
      onValueChange={onValueChange}
      placeholder={placeholder}
      mode={mode}
      suffix={suffix}
      max={
        max !== null
          ? max
          : maxIntegerDigits && maxIntegerDigits >= 0
            ? 10 ** maxIntegerDigits - (fractionDigits && fractionDigits >= 0 ? 10 ** -fractionDigits : 1)
            : null
      }
      min={
        min !== null
          ? min
          : maxIntegerDigits && maxIntegerDigits >= 0
            ? -(10 ** maxIntegerDigits - (fractionDigits && fractionDigits >= 0 ? 10 ** -fractionDigits : 1))
            : null
      }
      minFractionDigits={fractionDigits}
      maxFractionDigits={fractionDigits}
      showButtons={showButtons}
    />
  );
};

export default InputNumberPM;